import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { isLandlordTypeGuard } from "../../common/models/userInfo";
import { actionCreator } from "../../common/common.reducer";
import { DashboardForMeter } from "../../meter/components/dashboardForMeter";
import { IApplicationState } from "../../redux/root-reducer";
import { DashboardForSensors } from "../../safetySensors/components/dashboardForSensors";
import { OverviewCard } from "nodeDetails/components/overview/OverviewCard";
import { getAllSensorDataForSingleNode } from "safetySensors/Sensors.actions";
import { useParams } from "react-router-dom";
import { getAllMetersAction } from "meter/meter.actions";

const getStateProps = createSelector(
  (state: IApplicationState) => state.common,
  (commonState) => ({
    activeTab: commonState.activeDashboardTab,
    tenantAccessStatus: isLandlordTypeGuard(commonState.currentUserInfo)
      ? undefined
      : commonState.currentUserInfo.DomainSettings.TenantAccessStatus,
  })
);

export type DashboardTab = "Consumption" | "Sensors" | "Shell Protection";

export const TabsContainer = () => {
  const { tenantAccessStatus, activeTab } = useSelector(getStateProps);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id }: { id: string } = useParams();
  const domainCode = useSelector(
    (state: IApplicationState) => state.common.selectedDomain!.Code
  );

  const { userIsReady, currentUserInfo } = useSelector(
    (state: IApplicationState) => state.common
  );
  const [prevId, setPrevId] = useState<string | null>(null);

  const isLandlord = isLandlordTypeGuard(currentUserInfo);

  useEffect(() => {
    if (userIsReady && prevId !== id) {
      dispatch(getAllSensorDataForSingleNode(domainCode, parseInt(id!)));
      if (!isLandlord) {
        dispatch(getAllMetersAction(domainCode, id));
      }
      setPrevId(id);
    }
  }, [domainCode, id, userIsReady]);
  return (
    <>
      <Tabs
        value={activeTab}
        variant="fullWidth"
        onChange={(_, value: DashboardTab) => {
          dispatch(actionCreator.setActiveDashboardTab(value));
        }}
      >
        <Tab label={t("Meter")} value={"Consumption"} />
        <Tab label={t("Safety")} value={"Sensors"} />
        {tenantAccessStatus && (
          <Tab
            disabled={!tenantAccessStatus?.canViewMeters}
            label={t("Shell protection")}
            value={"Shell Protection"}
          />
        )}
      </Tabs>
      {activeTab === "Consumption" && <OverviewCard />}
      {activeTab === "Sensors" && <DashboardForSensors />}
      {activeTab === "Shell Protection" && <DashboardForMeter />}
    </>
  );
};

export default TabsContainer;
